import React from 'react';
import Lottie from 'react-lottie';
import { useIntl } from 'react-intl';

import PaperworkAuthLoader from '../../../../assets/images/lotties/PaperworkAuthLoader.json';

import styles from './index.styl';

const animationOptions = {
  loop: true,
  autoplay: true,
  animationData: PaperworkAuthLoader,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const AppointmentSessionLoader = () => {
  const { formatMessage } = useIntl();

  const title = formatMessage({
    id: 'paperwork.dialog.verifyingLink',
  });

  return (
    <section className={styles.section}>
      <div className={styles.content}>
        <Lottie options={animationOptions} height={200} width={200} />
        <div className={styles.title}>{title}</div>
      </div>
    </section>
  );
};

export default AppointmentSessionLoader;



// WEBPACK FOOTER //
// ./src/components/Paperwork/components/AppointmentSessionLoader/index.jsx